import { WidgetProps } from '@rjsf/utils';

import HandlebarFormControl from 'dashboard/components/HandlebarFormControl';
import { HandlebarsFieldType } from 'dashboard/models/workflow-schema';

export function HandlebarsWidget({
  id,
  value,
  disabled,
  formContext,
  onChange,
  uiSchema,
  rawErrors = [],
}: WidgetProps) {
  const rawType = uiSchema?.['ui:options']?.type;
  let type: 'input' | 'text-area' | 'code';
  if (typeof rawType !== 'string') {
    type = 'input';
  } else if (rawType !== 'input' && rawType !== 'text-area' && rawType !== 'code') {
    type = 'input';
  } else {
    type = rawType;
  }

  return (
    <HandlebarFormControl
      id={id}
      size='md'
      type={type}
      value={value}
      editable={!disabled}
      jsonSchema={formContext.jsonSchema}
      tokensToDisplayValue={formContext.tokensToDisplayValue}
      allowedTypes={uiSchema?.['ui:options']?.allowedFieldTypes as HandlebarsFieldType[]}
      hasError={rawErrors.length > 0}
      updateValue={onChange}
    />
  );
}
